<style scoped>
    .expand-row{
        margin-bottom: 16px;
    }
</style>
<template>
    <el-row>
        <el-col :span="8"  v-for="item in income" :key="keys">{{item.name}}:{{item.money}}</el-col>
    </el-row>
</template>
<script>
    export default {
        props: {
            income: Object
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/finance/table-expand.vue